import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const ReportHeader = ({ siteData }) => {
  const { t } = useLanguage();
  const currentDate = new Date()?.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });

  return (
    <div className="bg-card border border-border rounded-lg p-6 md:p-8 shadow-elevation-2 print:shadow-none print:border-2">
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
        <div className="flex items-start gap-4">
          <div className="flex items-center justify-center w-12 h-12 md:w-16 md:h-16 bg-primary rounded-lg flex-shrink-0">
            <Icon name="HardHat" size={28} color="var(--color-primary-foreground)" className="md:w-8 md:h-8" />
          </div>
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground mb-1">SiteProof</h2>
            <p className="text-sm text-muted-foreground">{t('constructionCompliancePlatform')}</p>
          </div>
        </div>
        
        <div className="text-left md:text-right">
          <p className="text-sm text-muted-foreground mb-1">{t('reportGenerated')}</p>
          <p className="text-base font-semibold text-foreground">{currentDate}</p>
        </div>
      </div>

      <div className="mt-6 pt-6 border-t border-border">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <p className="text-xs text-muted-foreground uppercase tracking-wide mb-1">{t('siteName')}</p>
            <p className="text-base font-semibold text-foreground">{siteData?.site_name || 'N/A'}</p>
          </div>
          
          <div>
            <p className="text-xs text-muted-foreground uppercase tracking-wide mb-1">{t('client')}</p>
            <p className="text-base font-semibold text-foreground">{siteData?.client_name || 'N/A'}</p>
          </div>
          
          <div>
            <p className="text-xs text-muted-foreground uppercase tracking-wide mb-1">{t('siteReference')}</p>
            <p className="text-base font-medium text-foreground">{siteData?.site_reference || 'N/A'}</p>
          </div>
          
          <div>
            <p className="text-xs text-muted-foreground uppercase tracking-wide mb-1">{t('location')}</p>
            <p className="text-base font-medium text-foreground">
              {siteData?.city && siteData?.postcode ? `${siteData?.city}, ${siteData?.postcode}` : 'N/A'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportHeader;